import React from 'react'
import {
  LoginContextVerificationDataType,
  useLoginContext
} from 'front-end/src/pages/auth/login/LoginContext'
import { useAsyncCallback } from '../useAsyncCallback'

type VerificationControllerProps = {
  children: (onFormSubmit, verificationLoading: boolean) => React.ReactElement
  submit(): Promise<void>
}

export const VerificationController: React.FC<VerificationControllerProps> = ({
  children,
  submit
}) => {
  const { setVerificationData } = useLoginContext()

  const [onFormSubmit, loading] = useAsyncCallback(
    async (formData: LoginContextVerificationDataType) => {
      setVerificationData(formData)
      await submit()
    }
  )

  return children(onFormSubmit, loading)
}
